import { IntegrationPuzzleIcon } from 'components/icons';

export const NoIntegrationsPlaceholder = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full p-10 bg-white border shadow-md rounded-2xl h-segments-284px">
      <IntegrationPuzzleIcon />
      <p className="mt-3 opacity-30">Connect your first integration below!</p>
    </div>
  );
};
